export default __webpack_public_path__ + "static/media/icn-operatives-aspects-off.f0c08c24.svg";